import React, { useState, useRef, useEffect, useCallback } from "react";
import classNames from "classnames/bind";
import { InputTextBox, Loading, Pagination, Toast } from "../../../../components";
import { SearchBlack, List } from "../../../../components/Icons/Icons";
import styles from "./Camera.module.css";
import axiosClient from "../../../../services/axiosClient";
import NameCol from "../../../../components/NameCol";
import { searchingCameraRoleFE, sorterArray } from "../../../../utils";
import ModalFill from "./ModalFill";

const cx = classNames.bind(styles);
const Camera = ({ code, company, setListCamera, listCamera }) => {
  const [isRefresh, setIsRefresh] = useState(false)
  const [input, setInput] = useState()
  const [textSearch, setTextSearch] = useState()
  const [check, setCheck] = useState({})
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const [pages, setPages] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [allCamera, setAllCamera] = useState();
  const [codeFill, setCodeFill] = useState('all');
  const [data, setData] = useState();
  const [camUser, setCamUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [baseData, setBaseData] = useState();
  const ref = useRef();

  useEffect(() => {
    if (code) {
      setCodeFill('all')
      setCurrentPage(1)
    } else {
      setCodeFill('all')
      setCheck({})
    }
  }, [code])

  const getAllCam = useCallback(async (currentPage, size, textSearch) => {
    setIsLoading(true)
    try {
      let params = {
        page: currentPage,
        size: size,
        company_code: company && company !== 'DEFAULT' ? company : null,
        camera_name: textSearch
      }
      const res = await axiosClient.get(`/cameraManagement/get-list-camera-user-cam/`, { params });
      setIsLoading(false)
      return res;
    } catch (error) {
      setIsLoading(false)
    }
  }, [company])

  const getAll = useCallback(async (currentPage, textSearch) => {
    let size = 10;
    try {
      const dataApi = await getAllCam(currentPage, size, textSearch)
      setData(dataApi)
      setBaseData(dataApi)
      setPages(Math.ceil(dataApi?.count / 10))
    } catch (error) {
    }
  }, [codeFill])
  const getCamOfUser = async (code) => {
    setIsLoading(true)
    try {
      const res = await axiosClient.get("/userCam/get-list-cam-userCam/", {
        params: {
          username: code,
          company_code: company
        }
      })
      setIsLoading(false)
      return res;
    }
    catch (e) {
      setIsLoading(false)
      if (e.response.status === 403) {
        Toast.open("Bạn không có quyền phân camera cho người dùng", "danger")
      }
    }
  }

  async function getData(code) {
    let res = await getCamOfUser(code)
    let checked = {}
    res?.data.forEach(item => {
      checked = { ...checked, [item.CODE]: true }
    })
    setCheck(checked)
    setListCamera(res.data)
    setCamUser(res)
  }

  const onChangeTextSearch = (data) => {
    setInput(data);
    setCurrentPage(1);
    setCodeFill('all');
    if (ref.current) {
      clearTimeout(ref.current);
    }
    ref.current = setTimeout(() => {
      setTextSearch(data);
      setIsRefresh(!isRefresh)
    }, 300);
  };
  const handleCheckCam = (e, camera) => {
    const { checked, name } = e.target
    setCheck({ ...check, [name]: checked })
    if (checked && listCamera) {
      setListCamera([...listCamera, camera])
    }
    else {
      const data = listCamera?.filter((item) => item.CODE !== camera.CODE)
      setListCamera(data)
    }
  }

  useEffect(() => {
    const newData = data ? data : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData.data, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData.data, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData.data)
          break;
      }
    } else {
      setDataTable(newData?.data)
    }
  }, [data, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  const handleChosePage = (data) => {
    setCurrentPage(data)
  }
  const handleNext = () => {
    setCurrentPage(currentPage + 1)
  }
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1)
  }

  const handleCheckAll = async (e) => {
    if (e.target.checked) {
      let listCam = [];
      if (allCamera) {
        listCam = [...allCamera]
      } else {
        let listAllCam = await getAllCam();
        listCam = listAllCam.data
      }
      setAllCamera(listCam)
      setListCamera(listCam)
      let listCheck = {};
      listCam?.forEach(item => {
        listCheck[`${item.CODE}`] = e.target.checked;
      })
      setCheck(listCheck)
    } else {
      setListCamera([])
      setCheck({})
    }
  }
  const handleFillCamRole = async (codeFill) => {
    try {
      if (code) {
        setCodeFill(codeFill);
        setCurrentPage(1);
      }
    } catch (error) {
      // // console.log(error);
    }
  }

  useEffect(() => {
    if (codeFill === 'all') {
      getAll(currentPage, textSearch);
    }
  }, [isRefresh, textSearch, currentPage, code, codeFill])

  useEffect(() => {
    if (codeFill === 'all' && code) {
      getData(code);
    }
  }, [isRefresh, code, codeFill])
  const getCamFill = useCallback(async () => {
    if (codeFill !== 'all' && code) {
      if (codeFill === 1) {
        let listCamDefault = searchingCameraRoleFE(currentPage, 10, baseData?.data, camUser.data, codeFill);
        setPages(Math.ceil(listCamDefault.total / 10));
        setData(prev => ({ ...prev, data: listCamDefault.data }));
      } else {
        try {
          const dataApi = await getAllCam(null, null, textSearch)
          let listCamDefault = searchingCameraRoleFE(currentPage, 10, dataApi?.data, camUser.data, codeFill);
          setPages(Math.ceil(listCamDefault.total / 10));
          setData(prev => ({ ...prev, data: listCamDefault.data }));
        } catch (error) {
          // // console.log(error);
        }
      }
    }
  }, [codeFill, currentPage, code, baseData, camUser])
  useEffect(() => {
    getCamFill()
  }, [codeFill, currentPage])
  return (
    <div className={cx("contemt")}>
      <div className={cx("search")}>
        <div className={cx("title-list")}>
          <List />
          <p>Danh sách Camera</p>
        </div>
        <div className={cx("search-form")}>
          <InputTextBox
            style={{ paddingTop: 2, width: '100%', marginRight: '16px' }}
            type="text"
            placeholder="Tìm kiếm"
            className={cx("pd")}
            value={input}
            onChange={onChangeTextSearch}
          />
          <span className={cx("icon-search")}>
            <SearchBlack />
          </span>
          <div className={cx('fill-icon')}>
            <ModalFill onSubmitFill={handleFillCamRole} filCode={codeFill} />
          </div>
        </div>
      </div>
      <div className={cx("data")}>
        <table className={cx("table")}>
          <thead>
            <tr>
              <th>STT</th>
              <th>
                <NameCol active={method} title={'Tên camera'} handleSort={handleSort} method={'NAME_CAM'} />
              </th>
              <th>
                <NameCol active={method} title={'Kho'} handleSort={handleSort} method={'NAME_CAM'} />
              </th>
              <th>
                <NameCol active={method} title={'Công ty'} handleSort={handleSort} method={'COMPANY_NAME'} />
              </th>
              <th>
                <NameCol active={method} title={'Địa điểm'} handleSort={handleSort} method={'PROVINCE_NAME'} />
              </th>
              <th >
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  Chọn
                  <input
                    type="checkbox"
                    style={{ display: 'inline-block', margin: '0px 0px 0px 8px' }}
                    onChange={handleCheckAll}
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <>
                <Loading />
              </>
            ) : (
              <>
                {dataTable &&
                  dataTable?.length > 0 &&
                  dataTable?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              alignItems: "center",
                            }}
                          >
                            {item?.NAME_CAM}
                          </div>
                        </td>
                        <td>
                          {item?.WAREHOUSE_NAME}
                        </td>
                        <td>{item?.COMPANY_NAME}</td>
                        <td>{item?.PROVINCE_NAME}</td>
                        <td style={{ textAlign: "right", paddingRight: '8px' }}>
                          <input name={item?.CODE} checked={check[`${item?.CODE}`] ? check[`${item?.CODE}`] : false} onChange={(e) => handleCheckCam(e, item)} type="checkbox" />
                        </td>
                      </tr>
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
        <div className={cx('pagination')}>
          {dataTable?.length > 0 && (
            <Pagination
              pages={pages}
              currentPage={currentPage}
              onClick={(data) => handleChosePage(data)}
              onNext={handleNext}
              onPrevious={handlePrevious}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Camera;
